export class DCCommunityPortalInternalProduct {
    "DC HS Code": string = "";
    "DC Product English Name": string = "";
    "DC Product Arabic Name": string = "";
    "DC Country of Origin": string = "";
    "DC Unit of Measure": string = "";
    "DC Unit Price": string = "";
    "DC Quantity": string = "";
    "DC Weight": string = "";
    "DC Process Type": string = "";
    "DC Processing Country": string = "";
    "DC Category Desc": string = "";
}

export class DCCommunityPortalSRNotes {
    "Note": string = "";
    "Note Type": string = "";
}

export class DCCommunityPortalTravelPlans {
    "DC Visit Transit": string = "";
    "DC Travel Country": string = "";
    "DC Travel Start Date": string = "";
    "DC Travel End Date": string = "";
    "DC Transport Means": string = "";
    "DC Intended Use": string = "";
    "DC Additional Vchor": string = "";
    "DC Additional Cfoil": string = "";
}

export class DCCommunityPortalSR {
    "SR Number": string = "";
    "CSN": string = "";
    "SR Type": string = "";
    "Sub Type": string = "";
    "DC Payment Method": string = "Online";
    "DC Channel": string = "Online";
    "DC Processing Type": string = "";
    "DC Collection Option": string = "";
    "DC Open Country": string = "";
    "DC Building Name": string = "";
    "DC Area": string = "";
    "DC Emirates": string = "";
    "DC Additional Consignee Address": string = "";
    "DC Carnet Number"?: string = ""
    "DC ATA Applicant Type": string = "";
    "DC Represented By": string = "";
    "DC Holder Phone": string = "";
    "DC Holder Mobile": string = "";
    "DC Holder Email": string = "";
    "DC Holder Fax": string = "";
    "DC Holder Proof Type": string = "";
    "DC Holder Id": string = "";
    // "DC ATA Company Name": string = "";
    // "DC ATA Business Type": string = "";
    // "DC ATA Company Mobile": string = "";
    // "DC ATA Company Telephone": string = "";
    // "DC ATA Comp Rep Name": string = "";
    // "DC ATA Comp Rep Email": string = "";
    // "DC ATA Comp Rep Mobile": string = "";
    // "DC ATA Comp Rep Telephone": string = "";
    "DC Holder Bank Name": string = "";
    "DC ATA Payment Method": string = "";
    "DC IBAN No": string = "";
    "DC Account Holder": string = "";
    "Currency": string = "AED";
    "DC Expected Departure Date": string = "";
    "DC Intended Use Type": string = "";
    "DC Reimport Date": string = "";
    "DC Additional Detail": string = "";
    "DC ATA Reason": string = "";
    "DC Courier Email Addr": string = "";
    "DC Courier Mobile": string = "";
    "DC ATA Consent": string = "Y";
    "DC ATA Pledged Letter Consent": string = "Y";
    "DC Bank Detail Consent": string = "Y";
    "DC ATA Company License Check": string = "";
    "DC ATA Company Emirate": string = "";
    "DC Member Name ENU": string = "";
    "DC Member Name ARA": string = "";
    "ListOfDC Community Portal Internal Product" = {
        "DC Community Portal Internal Product": [] as DCCommunityPortalInternalProduct[] | null
    };

    "ListOfDC Community Portal SR Notes" = {
        "DC Community Portal SR Notes": null as DCCommunityPortalSRNotes[] | null
    };

    "ListOfDC Community Portal Travel Plans" = {
        "DC Community Portal Travel Plans": [] as DCCommunityPortalTravelPlans[] | null
    };
}

export class ListOfDCCommunityPortalSRUpsertIO {
    "DC Community Portal SR": DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DC Community Portal SR Upsert IO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    "ListOfDC Community Portal SR Upsert IO": ListOfDCCommunityPortalSRUpsertIO = new ListOfDCCommunityPortalSRUpsertIO();
}

export class IssueAtaCarnetBody {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "SAVEASDRAFT";
    DCLoginName: string = "";
    DCLanguage: string = "ENU";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class IssueAtaCarnetRequest {
    body: IssueAtaCarnetBody = new IssueAtaCarnetBody();
}
